export default {
  columns: {
    offerName: 'Aanbiedingsnaam',
    type: 'Type',
    status: 'Status',
    active: 'Actief',
    inactive: 'Inactief',
    details: 'Details',
    schedule: 'Schema',
    startDate: 'Startdatum',
    images: 'Afbeelding',
  },
  actions: {
    edit: 'Bewerken',
    rename: 'Hernoemen',
    delete: 'Verwijderen',
    set_active: 'Activeren',
    set_inactive: 'Deactiveren',
    cancel: 'Annuleren',
    confirm: 'Bevestigen',
    activate: 'Vervangen & activeren',
    manage_images: 'Afbeelding bewerken',
  },
  toasts: {
    offer_enabled: '{{offer}} is nu de actieve aanbieding voor {{for}}',
    offer_disabled: '{{offer}} ingesteld op Inactief.',
    update_failed: 'Het bijwerken van de aanbieding is mislukt.',
    successfully_deleted: 'De aanbieding is succesvol verwijderd',
    delete_failed: 'Het verwijderen van de aanbieding is mislukt',
  },
  title: 'Alle aanbiedingen beheren',
  popups: {
    delete: {
      title: 'Weet u zeker dat u deze aanbieding wilt verwijderen?',
    },
    toggle: {
      title_overlapping_is_not_allowed: 'Het vervangen van masteraanbiedingen is niet toegestaan',
      title: 'Actieve aanbieding vervangen voor deze periode?',
      description:
        'U activeert {{offer}} op {{weekday}}{{between}}. Dit deactiveert de huidige actieve aanbieding {{currentOffer}} voor dezelfde periode.',
      between: ', tussen {{start}}-{{end}}',
    },
  },
};
